type ColorObject = {
  [key: string]: string;
};

const brandColors: ColorObject = {
  brandLight: '#ECFCF9',
  brandDark: '#063737',
  brand: '#00D9C5',
} as const;

const actionColors: ColorObject = {
  action: 'linear-gradient(90deg, #4F5AD8 0%, #3B46C4 100%)',
  actionPlain: '#3B46C4',
  actionLight: '#E9EAFA',
  actionDark: '#21247F',
} as const;

const neutralColors: ColorObject = {
  greyLightest: '#F7F7F7',
  greyLighter: '#EFEFEF',
  greyDarkest: '#2C3236',
  greyLight: '#D4D7D9',
  greyDark: '#4A545E',
  white: '#FFFFFF',
  black: '#000000',
  grey: '#818F9B',
} as const;

const notificationColors: ColorObject = {
  warningLight: '#FFECCE',
  successLight: '#DDFDE5',
  warningDark: '#704300',
  successDark: '#17592B',
  alertLight: '#FFDAD8',
  alertDark: '#940700',
  warning: '#FF9F0A',
  success: '#3EBC64',
  alert: '#db003e',
} as const;

const jlMoneyColors = {
  jlMoneyGreyLightest: '#DCDCDC',
  jlMoneyOrangeBright: '#FF5630',
  jlMoneyOrangeLight: '#FFF7E5',
  jlMoneyGreenLight: '#F9FFE5',
  jlMoneyGreenDark: '#102B2B',
  jlMoneyGreenNeon: '#DFFF7B',
  jlMoneyGreyLight: '#A9A9A9',
  jlMoneyBlueLight: '#EAF2FE',
  jlMoneyPinkLight: '#FFEEEA',
  jlMoneyGreyDark: '#333333',
  jlMoneyBlueNeon: '#6A4EFF',
  jlMoneyBeige: '#EEEAE4',
  jlMoneyAmber: '#FFAB00',
  jlMoneyGrey: '#53565A',
  jlMoneyBlue: '#2E80F6',
  jlMoneyRed: '#D50032',
};

export type Colors = typeof notificationColors &
  typeof neutralColors &
  typeof jlMoneyColors &
  typeof actionColors &
  typeof brandColors;

const colors: Colors = {
  ...brandColors,
  ...actionColors,
  ...neutralColors,
  ...notificationColors,
  ...jlMoneyColors,
};

export { notificationColors, neutralColors, jlMoneyColors, actionColors, brandColors, colors };
